<template>
    <div class="parentPopup">
        <div class="popup">
            <p class="name">家长，您好~</p>
            <p class="detail">为了更好的进行学业规划服务，请确认并输入下列信息进行验证：</p>
            <el-form :model="form" :rules="rules" ref="bindStudent"  class="studentQues" label-position="right"  >
                <el-row type="flex" justify="space-between" :gutter="20">
                    <el-col :span="11">
                        <el-form-item label="您的姓名：" prop="parentName">
                            <el-input v-model="form.parentName" maxLength={25} placeholder="" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="13">
                        <el-form-item  label="家长身份：" prop="parentIdentity" label-width="110px" >
                            <el-input v-model="form.parentIdentity" maxLength={25}  ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="space-between" :gutter="20">
                    <el-col :span="11">
                        <el-form-item label="学生姓名：" prop="studentName">
                            <el-input v-model="form.studentName" maxLength={25} placeholder="" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="13">
                        <el-form-item  label="学生手机号：" prop="studentPhone"  label-width="110px">
                            <el-input v-model="form.studentPhone" maxLength={25} placeholder="学生注册时用的手机号" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item class="btn">
                    <el-button type="primary" @click="submitForm('bindStudent')">确认</el-button>
                </el-form-item>
            </el-form>
            <div class="close" @click="$emit('closePop')"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "parentPopup",
    data() {
        return {
            form: {
                parentName: '',
                parentIdentity: '',
                studentName: '',
                studentPhone: '',
            },
            rules: {
                parentName: [
                    { required: true, message: '请填写该内容', trigger: 'blur' },
                ],
                parentIdentity: [
                    { required: true, message: '请选择', trigger: 'blur' },
                ],
                studentName: [
                    { required: true, message: '请填写该内容', trigger: 'blur' },
                ],
                studentPhone: [
                    { required: true, message: '请填写该内容', trigger: 'blur' },
                ]
            }
        }
    },
    methods: {

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // alert('submit!');
                    let params = this.form;
                    this.$ajax.post(this.G_acapi+this.ports.parent.message.getStudentDataByPhoneAndName,params,{
                        headers:{
                            token: window.sessionStorage.getItem('ymtxToken')
                        }
                    }).then((res)=>{
                        if(res.data.code==2000){
                            this.$message({
                                message: '绑定成功',
                                type: 'success'
                            });
                            this.$emit('closePop');
                            this.$emit('finish');
                        }else{
                            this.$message({
                                message: res.data.msg,
                                type: 'error'
                            });
                        }
                    })
                }
            });
        }
    },

}
</script>

<style scoped lang="less">
.parentPopup {
    background: rgba(153, 153, 153, 0.8);
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    .popup {
        box-sizing: border-box;
        padding: 74px 40px 0 40px;
        width: 575px;
        height: 434px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -287px;
        margin-top: -217px;
        background: url("/imgs/xueyezixun/studentAndParent/popup.png");
        .name {
            line-height: 30px;
            color: #fff;
            font-weight: 500;
            margin-bottom: 120px;
            font-size: 20px;
        }
        .detail {
            line-height: 20px;
            margin-bottom: 20px;
        }
    }
    .el-button--primary {
        padding: 0;
        width: 146px;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
        background: #3D90F6;
        border-radius: 4px;
        text-align: center;
        margin: 0 auto;
        color: #fff;
    }
    .close {
        width: 36px;
        height: 36px;
        position: absolute;
        top: 0px;
        right: 2px;
        cursor: pointer;
    }

}
</style>